import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const legalDocumentsSkeletons: TSkeletons = [{ height: '100vh', styleName: 'whiteGray' }]
